import * as React from 'react';

import { DisplayAd } from 'constants/ads';

import { MesoDisplayAd } from './meso-display-ad';
import { MesoTrigger } from './meso-trigger';

interface MesoSideRailProps {
  pageName: string;
}

export class MesoSideRail extends React.Component<MesoSideRailProps> {
  public render() {
    const { pageName } = this.props;

    return (
      <>
        <MesoDisplayAd {...DisplayAd.SIDERAIL_R1} />
        <MesoDisplayAd {...DisplayAd.SIDERAIL_RM} />
        <MesoDisplayAd {...DisplayAd.SIDERAIL_R2} />
        <MesoTrigger pageName={pageName} />
      </>
    );
  }
}
